export default "__VITE_ASSET__0sTb6rD0__"